import MicroModal from 'micromodal';

class Modal {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        MicroModal.init({
            disableFocus: true
        });
    }
}

export default Modal;